// deps
import cx from "classnames";
import React, { ReactElement, memo } from "react";

// internal-deps
import { isNil } from "@swiggy-private/js-utils";

// helpers
import { replaceText } from "@swiggy-private/core-ui";

// styles
import styles from "./OrderConfirmSubText.scss";

interface OrderConfirmSubTextProps {
    superMessage?: {
        successMessage: string;
        successMessageInfo: string;
    };
    subtext: string;
    className?: string;
}

function OrderConfirmSubText({ superMessage, subtext, className }: OrderConfirmSubTextProps): ReactElement {
    const subTextClass = cx(styles.superText, className);

    if (superMessage == null || superMessage?.successMessageInfo === "") {
        return <>{!isNil(subtext) && <div className={subTextClass}>{replaceText(subtext, styles.logo)}</div>}</>;
    }

    return (
        <div className={subTextClass}>
            {replaceText(superMessage.successMessage, styles.logo)}
            {replaceText(superMessage.successMessageInfo, styles.logo)}
        </div>
    );
}

export default memo(OrderConfirmSubText);
